import colors from '../../colors';
import * as React from 'react';
import styled from 'styled-components';
import { baseFormStyles } from '../../../util/styles';
import * as SendIcon from 'react-icons/lib/io/ios-paperplane';
import BaseSendForm, { BaseProps, BaseState, initialState } from '../BaseSendForm';

interface Props extends BaseProps {
    updateDimensions: () => void;
}

export default class SendForm extends BaseSendForm<Props, BaseState> {
    state = initialState;

    constructor(props: Props) {
        super(props);
        this.handleResize = this.handleResize.bind(this);
    }

    componentDidMount() {
        // do NOT focus automatically
    }

    handleResize() {
        this.props.updateDimensions();
    }

    public render() {
        const { message } = this.state;
        const { disabled } = this.props;

        return (
            // must have "action" for iOS to show the "go" button
            <Wrapper action="#">
                <Input
                    innerRef={c => (this.inputRef = c)}
                    onChange={this.handleInputChange}
                    onKeyDown={this.handleKeyDown}
                    onFocus={this.handleResize}
                    onBlur={this.handleResize}
                    value={message}
                />
                <Button onClick={this.handleButtonClick} disabled={disabled}>
                    <SendIcon size={29} />
                </Button>
            </Wrapper>
        );
    }
}

const Wrapper = styled.form`
    padding: 10px;
    display: flex;
    justify-content: flex-end;
    align-items: center;
`;

const Input = styled.input`
    ${baseFormStyles} box-sizing: border-box;
    font-size: 16px; /* IMPORTANT! Mobile browser will zoom in on focus if the font-size is less than 16px */
    width: 100%;
    padding: 6px;
    border-right: 0;
    border-top-left-radius: 3px;
    border-bottom-left-radius: 3px;
    line-height: 1;
    height: 31px;
`;

export const Button = styled.button`
    background-color: ${colors.green};
    font-size: 11px;
    line-height: 1;
    color: ${colors.white};
    &:hover,
    &:focus {
        color: ${colors.white};
    }
    &:disabled {
        background-color: ${colors.mediumLightGray};
        color: ${colors.mediumDarkGray};
        border: 1px solid ${colors.mediumGray};
        cursor: not-allowed;
    }
    margin: 0;
    padding: 0;
    border: 1px solid ${colors.green};
    border-radius: 0 3px 3px 0;
    cursor: pointer;
    text-transform: uppercase;
    transition: all 0.1s ease-in;
    height: 31px;
    letter-spacing: inherit;

    &:focus {
        outline: none;
    }
`;



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/components/Conversation/Mobile/SendForm.tsx